import {Buffer} from 'buffer'

// @otplib/preset-browser is a UMD bundle. It reads a free global named `buffer`.
// The old unpkg script defined it. Webpack 4 does not, so the page stayed blank.
/** @type {any} */ (window).buffer = {Buffer}
